import React, { useState } from "react";
import emailjs from "emailjs-com";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Image from "../assets/imgSect6.svg";
import { FaWhatsapp } from "react-icons/fa";



const ContactForm = () => {
  const [formData, setFormData] = useState({
    from_name: "",
    name: "",
    company: "",
    phone: "",
    email: "",
    message: "",
    reply_to: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false); // Estado para bloquear el formulario tras envío
  const [errors, setErrors] = useState({}); // Estado para los mensajes de error

  // const phoneRegex = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/;
  const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Validación en tiempo real
    // if (name === "phone" && !phoneRegex.test(value)) {
    //   setErrors((prev) => ({ ...prev, phone: "Teléfono inválido. Debe incluir el código de país." }));
    // } else if (name === "phone") {
    //   setErrors((prev) => ({ ...prev, phone: "" }));
    // }

    if (name === "email" && !emailRegex.test(value)) {
      setErrors((prev) => ({ ...prev, email: "Correo electrónico inválido." }));
    } else if (name === "email") {
      setErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  const isFormValid = () => {
    return (
      formData.name.trim() !== "" &&
      formData.company.trim() !== "" &&
      formData.phone.trim() !== "" &&
      formData.email.trim() !== "" &&
      !errors.phone &&
      !errors.email
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const btn = document.getElementById("button");
    btn.value = "Enviando...";

    const serviceID = "default_service";
    const templateID = "template_21ir8ee";

    emailjs
      .send(serviceID, templateID, formData, "do8feBgt-Kff09J9g")
      .then(
        () => {
          setIsSubmitted(true); // Marca como enviado
          setFormData({
            from_name: "",
            name: "",
            company: "",
            phone: "",
            email: "",
            message: "",
            reply_to: "",
          });
        },
        (err) => {
          btn.value = "Enviar"; // Restablece el texto del botón en caso de error
          console.error("Error al enviar el formulario:", err);
        }
      );
  };
  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      phone: value,
    });

    if (!value || value.length < 8) {
      setErrors((prev) => ({ ...prev, phone: "Teléfono inválido." }));
    } else {
      setErrors((prev) => ({ ...prev, phone: "" }));
    }
  };
  return (
    <section className="items-center text-left" id="contacto">
      <div className="divider-conteiner space-y-2 px-20 mb:px-8 text-left items-start">
      <h2 className="divider-titule flex items-text-left">
  Contáctanos
  <button
    onClick={() => window.open("https://wa.me/573155381468?text=Hola,%20necesito%20informaci%C3%B3n%20sobre%20MentorIA", "_blank")}
    className="ml-2 text-green-500 text-['100%'] flex items-center"
  >
    <FaWhatsapp className="text-['100%']" />
  </button>
</h2>        <h2 className="divider-body items-start">
          Contáctanos hoy mismo y descubre todo lo que tenemos para ti
        </h2>
      </div>
      <div className="flex flex-col md:flex-row items-start text-left py-8  px-20 mb:px-8 mb:py-10">
        <div className="w-full md:w-[60%] form-conteiner p-0">
          <p className="form-subtitule">
            Déjanos tus datos y nos pondremos en contacto contigo
          </p>
          <form className="w-[90%] space-y-7" onSubmit={handleSubmit}>
            <input
              className="input-field"
              type="text"
              name="name"
              placeholder="Nombres Completos"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitted}
            />

            <input
              className="input-field"
              type="email"
              name="email"
              placeholder="Correo corporativo"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitted}
            />
            {errors.email && <p className="error-text">{errors.email}</p>}
  
            <div className="w-full">
              <PhoneInput
                country={"co"} // País inicial (puedes cambiarlo)
                value={formData.phone}
                onChange={handlePhoneChange}
                disabled={isSubmitted}
                inputStyle={{
                  width: "100%",
                  height: "2.5rem",
                  fontSize: "16px",
                  borderRadius: "0.2rem",
                  border: "none",
                  backgroundColor: "#f7f6f6c4",
                }}
                buttonStyle={{
                  backgroundColor: "#e9e8e8c4",
                  borderRadius: "0.2rem",
                  border: "none",
                }}
              />
            </div>
            {errors.phone && <p className="error-text">{errors.phone}</p>}
            <input
              className="input-field"
              type="text"
              name="company"
              placeholder="Empresa"
              value={formData.company}
              onChange={handleChange}
              disabled={isSubmitted}
            />
            <textarea
              className="input-field"
              name="message"
              placeholder="Mensaje (opcional)"
              value={formData.message}
              onChange={handleChange}
              disabled={isSubmitted}
            />
            <input
              className="input-field"
              type="hidden"
              name="reply_to"
              value={formData.email}
            />
            <input
              className={`btn-primary ${isSubmitted ? "btn-disabled" : ""}`}
              
              type="submit"
              id="button"
              value={isSubmitted ? "Enviado" : "Enviar"}
              disabled={!isFormValid() || isSubmitted}
            />
          </form>
        </div>
        <div className="w-full md:w-[40%] img-conteiner">
          <img src={Image} alt="Gráfico" className="max-w-full h-auto" />
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
